import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DataService } from './data.service';

@Injectable()
export class ArquivoService extends DataService {
  private url = this.urlApi + 'v1/arquivo/';
  public uploadUrl = this.url + 'uploadArquivo/';
  public uploadUrlAlterar = this.url + 'uploadAlterarArquivo/';

  constructor(private http: HttpClient, private _ngZone: NgZone) {
    super();
  }

  downloadArquivo(idArquivo, nomeArquivo) {
    this._ngZone.runOutsideAngular(() => {
      location.href =
        this.url + 'downloadArquivo/' + idArquivo + '/' + nomeArquivo;
    });
  }

  DownloadExcelConsultasCnpj(): any {
    return Observable.create(observer => {
      const xhr = new XMLHttpRequest();

      xhr.open('POST', this.url + 'downloadExcelConsultasCnpj', true);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.responseType = 'blob';

      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const contentType =
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send();
    });
  }

  removeArquivo(id: string) {
    return this.http
      .delete(this.url + 'removeArquivo/' + id)
      .catch(this.handleError);
  }

  getArquivo(id: string) {
    return this.http.get(this.url + 'getArquivo/' + id).catch(this.handleError);
  }

  cadastrarArquivoAlterado(arquivo) {
      return this.http.post( this.url + 'cadastrarArquivoAlterado/', arquivo)
      .catch(this.handleError);
  }

  getTipoArquivo(referencia: string, id: string) {
    return this.http.get(this.url + 'tipoArquivo/' + referencia + '/' + id).catch(this.handleError);
  }
  getTipoAnalise(referencia: string, id: string) {
    return this.http.get(this.url + 'tipoArquivo/' + referencia + '/' + id).catch(this.handleError);
  }
  upload(arquivo) {
    return this.http.post(this.url + 'upload', arquivo)
    .catch(this.handleError);
  }

  uploadArquivoPorTipo(arquivo,tipoArquivo) {
    return this.http.post(this.uploadUrl+''+tipoArquivo, arquivo);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/services/arquivo.service.ts